{
  "EmailRule_Failed": "O correio eletrónico deve ser válido",
  "NAME": "GenericRuleLanguage"
}